import { CSSProperties, memo } from 'react';

import {
  containerStyle,
  contentStyle
} from '@/components/Discovery/Card/styles/card-styles.ts';
import Content from '@/components/Discovery/Card/Components/Content.tsx';
import UIConfig from '@/UIConfig.ts';
import { CandidateUI } from '@/api/matchmaker/types.ts';

interface CardPreviewProps {
  data: CandidateUI;
  toggleFirstPhoto: boolean;
}

const CardPreview = ({ data, toggleFirstPhoto }: CardPreviewProps) => {
  return (
    <div style={containerWrapper}>
      <div
        style={{
          ...containerStyle,
          height: 'calc(100vh - 150px)',
          marginTop: 0
        }}
      >
        <div style={contentStyle}>
          <Content
            matchCandidate={data}
            isPreview
            toggleFirstPhoto={toggleFirstPhoto}
          />
        </div>
      </div>
    </div>
  );
};

const containerWrapper: CSSProperties = {
  width: '100vw',
  height: 'calc(100vh - 100px)',
  overflow: 'hidden',
  background: UIConfig.Colors.BackgroundDark
};

export default memo(CardPreview);
